import React, { useState } from 'react';
import { apiFetch } from '../../../api/apiClient';

export default function BackfillDividendsButton({ portfolioId, onDone }) {
  const [busy, setBusy]   = useState(false);
  const [msg, setMsg]     = useState('');

  async function handleClick() {
    if (busy) return;
    setBusy(true);
    setMsg('');
    try {
      const res = await apiFetch(`/api/portfolio-v2/backfill-dividends?portfolioId=${portfolioId}`, {
        method: 'POST',
      });
      if (!res.ok) throw new Error('Backfill failed.');
      const data = await res.json();
      const added   = data?.added   ?? 0;
      const skipped = data?.skipped ?? 0;
      const fxFixed = data?.fxFixed ?? 0;
      const parts = [];
      if (added)   parts.push(`Imported ${added}`);
      if (fxFixed) parts.push(`Fixed FX on ${fxFixed} existing`);
      if (!added && !fxFixed) parts.push('Everything is up to date');
      if (skipped) parts.push(`skipped ${skipped} duplicates`);
      setMsg(parts.join(' · '));
      setTimeout(() => setMsg(''), 6000);
      if ((added > 0 || fxFixed > 0) && onDone) onDone();
    } catch (err) {
      setMsg(err?.message || 'Backfill failed.');
      setTimeout(() => setMsg(''), 5000);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={wrap}>
      <button type="button" onClick={handleClick} disabled={busy} style={btn}>
        {busy ? 'Importing…' : 'Backfill historical dividends'}
      </button>
      {msg && <span style={note}>{msg}</span>}
    </div>
  );
}

const wrap = { display: 'inline-flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' };
const btn  = { padding: '8px 14px', borderRadius: '10px', border: '1px solid var(--border)', background: 'var(--surface-strong)', color: 'var(--text-primary)', fontSize: '13px', fontWeight: 700, cursor: 'pointer' };
const note = { fontSize: '12px', color: 'var(--text-secondary)' };
